import React, { useState, useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "../../config/axiosClient";
import Config from "../../config/Config";
import ClipLoader from "react-spinners/ClipLoader";

const API_BASE = Config().url;

export default function Activate() {
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    const apiLink = searchParams.get("api_activation_link");

    if (!apiLink) {
      setMessage("Invalid activation link.");
      setLoading(false);
      return;
    }

    // Extract the confirmation key from the activation URL
    // URL looks like: https://api.inertia7.com/api/v1/auth/registration/account-confirm-email/KEY/
    const keyMatch = apiLink.match(/account-confirm-email\/([^/]+)/);
    if (!keyMatch) {
      setMessage("Invalid activation link format.");
      setLoading(false);
      return;
    }

    const key = keyMatch[1];

    axios
      .post(`${API_BASE}api/v1/auth/confirm-email/`, { key })
      .then((res) => {
        setSuccess(true);
        setMessage(res.data?.detail || "Email verified successfully.");
        setLoading(false);
      })
      .catch((err) => {
        let errorMessage = "Activation failed.";
        if (err.response?.data?.detail) {
          errorMessage = err.response.data.detail;
        } else if (err.response?.status === 404) {
          errorMessage = "Activation link not found or expired.";
        } else if (err.response?.status === 400) {
          errorMessage = "Invalid activation link.";
        } else if (err.response?.status === 500) {
          errorMessage = "Server error. Please try again later.";
        }
        setMessage(errorMessage);
        setSuccess(false);
        setLoading(false);
      });
  }, [searchParams]);

  return (
    <div className="container signup-custom" style={{ textAlign: "center", paddingTop: 60 }}>
      <h1>{loading ? "Activating account..." : success ? "Account Verified" : "Activation Failed"}</h1>

      {loading && (
        <div style={{ marginTop: 30 }}>
          <ClipLoader size={60} color="#59c6c1" loading={true} />
        </div>
      )}

      {!loading && (
        <div style={{ marginTop: 20 }}>
          <p style={{ fontSize: 16, color: "var(--ink)" }}>{message}</p>
          {success ? (
            <Link
              to="/accounts/signin"
              style={{
                display: "inline-block",
                marginTop: 16,
                padding: "10px 28px",
                background: "var(--brand, #59c6c1)",
                color: "#fff",
                borderRadius: 6,
                fontWeight: 600,
                textDecoration: "none",
              }}
            >
              Sign In
            </Link>
          ) : (
            <Link
              to="/"
              style={{
                display: "inline-block",
                marginTop: 16,
                color: "var(--brand, #59c6c1)",
                fontWeight: 600,
              }}
            >
              Go Home
            </Link>
          )}
        </div>
      )}
    </div>
  );
}
